import styled from 'styled-components';

export const StyledSwipeModalContainer = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
`;
